import { useEffect } from 'react';

export function useElementObserver(
  selector: string,
  callback: (element: Element | null) => void,
  options: MutationObserverInit = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['id', 'class'],
  }
) {
  useEffect(() => {
    const checkElement = () => {
      const element = document.querySelector(selector);
      callback(element);
    };

    checkElement();

    const observer = new MutationObserver(() => {
      checkElement();
    });

    observer.observe(document.body, options);

    return () => observer.disconnect();
  }, [selector, callback, options]);
}
